import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { ProposalOrderField } from "work/proposals/__constants/proposal-lifecycle";
import { z } from "zod";

export type ProposalOrderJSON = z.infer<typeof ProposalOrderSchema.ProposalOrderJSONZ>;
export type ProposalOrderParametersProps = z.infer<typeof ProposalOrderSchema.ProposalOrderZ>;

export default class ProposalOrderSchema {
  public static readonly ProposalOrderJSONZ = z.object({
    orderBy: z.enum(ProposalOrderField),
    orderDir: z.enum(OrderDirection),
  });
  public static readonly ProposalOrderZ = z.object({
    orderBy: z.enum(ProposalOrderField),
    orderDir: z.enum(OrderDirection),
  });

  public static validateJSON(values: unknown): ProposalOrderParametersProps {
    return parseOrThrow(ProposalOrderSchema.ProposalOrderZ, values, {
      logError: true,
      schemaName: "ProposalOrderSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is ProposalOrderParametersProps {
    try {
      ProposalOrderSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: ProposalOrderJSON): ProposalOrderParametersProps {
    const parsed = parseOrThrow(ProposalOrderSchema.ProposalOrderJSONZ, data, {
      logError: true,
      schemaName: "ProposalOrderSchema",
      operation: "deserialize",
      payloadSample: data,
    });
    return ProposalOrderSchema.codec.decode(parsed);
  }

  public static serialize(props: ProposalOrderParametersProps): ProposalOrderJSON {
    const parsed = ProposalOrderSchema.validateJSON(props);
    return ProposalOrderSchema.codec.encode(parsed);
  }

  private static readonly codec = z.codec(ProposalOrderSchema.ProposalOrderJSONZ, ProposalOrderSchema.ProposalOrderZ, {
    decode: (data) => ({
      orderBy: data.orderBy,
      orderDir: data.orderDir,
    }),
    encode: (proposal) => ({
      orderBy: proposal.orderBy,
      orderDir: proposal.orderDir,
    }),
  });
}
